<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    paymentMethod: Object,
    selectedNewPaymentMethod: String,
    showToggle: Boolean,
    isOverview: Boolean
});

const emit = defineEmits(['update:selectedNewPaymentMethod']);

const isSafari = ref(false);

onMounted(() => {
    isSafari.value = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
});

const handleClick = () => {
    if (props.paymentMethod.id === 'APPLEPAY' && !isSafari.value) return;
    emit('update:selectedNewPaymentMethod', props.paymentMethod.id);
};
</script>

<template>
    <div
        @click="handleClick"
        class="bg-white flex flex-row items-center gap-4 p-2 rounded-md shadow-md"
        :class="{ 'disabled-payment': paymentMethod.id === 'APPLEPAY' && !isSafari }"
    >
        <div v-if="!isOverview" class="flex items-center justify-center cursor-pointer ml-2">
            <div class="w-4 h-4 rounded-full border border-blue" :class="{ 'bg-blue': paymentMethod.id === selectedNewPaymentMethod }" />
        </div>
        <div v-else>
            <i class="fi fi-rr-check text-green text-xs mr-1"></i>
        </div>
        <div v-if="!isSafari && paymentMethod.id === 'APPLEPAY'" class="flex flex-row justify-between w-full items-center">
            <small> {{ paymentMethod.name }} ({{ $t('safari_browser_only') }}) </small>
            <img :alt="paymentMethod.name" :src="$asset(`/hkcm/images/payment-methods/${paymentMethod.id.toLowerCase()}.svg`, 'public')" class="h-10" />
        </div>
        <div v-else class="flex flex-row justify-between w-full items-center">
            <small>
                {{ paymentMethod.name.includes('_') ? $t(paymentMethod.name) : paymentMethod.name }}
            </small>

            <img :alt="paymentMethod.name" :src="$asset('/hkcm/images/payment-methods/' + paymentMethod.id.toLowerCase() + '.svg', 'public')" class="h-10" />
        </div>
    </div>
</template>
<style scoped>
.disabled-payment {
    background-color: #f3f3f3;
    color: #a0a0a0;
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
}
</style>
